// extracted by mini-css-extract-plugin
module.exports = {"label":"s_b8","text":"s_cd"};